import { Observable } from 'rxjs';
import { PlatformConfigService } from '../services/platform-config.service';

export function initializePlatformConfig(
  platformConfigService: PlatformConfigService
): () => Observable<any> {
  return () => {
    console.log('🚀 [APP_INITIALIZER] Loading platform configuration...');
    return platformConfigService.loadConfig();
  };
}